import { IRefIds } from 'constants/refs';
import { get, post, put } from 'services/request';
import { IItemId } from 'types/content';
import { BaseModel, IModelOptions } from './BaseModel';
import { ICourse, ICourseEdit } from '../types/courses';

export default class CoursesModel extends BaseModel<ICourse, ICourseEdit> {
  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.courses;
    this.gridName = 'Courses';
    this.getGrid();
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<ICourse[]>(`courses`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<ICourse>(`courses/${itemId}/grid-row`);
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async new() {
    await super.new();
    const item = await get<ICourseEdit>(`courses/new`);
    await this.setItem(item);
    this.render();
  }

  async save() {
    await super.save();
    const item = this.itemUpdated as ICourseEdit;
    if (item.id === this.NEW_CREATE_ID) {
      await this.createItem();
    } else {
      await this.updateItem();
    }
  }

  async createItem() {
    const item = this.itemUpdated as ICourseEdit;
    const result = await post<IItemId>(`courses`, item);

    if (result.ok && result.data) {
      const newItemId = result.data.id;
      await Promise.all([this.updateGridRow(newItemId, 'add'), this.loadItemEdit(newItemId)]);
    }
  }

  async updateItem() {
    const item = this.itemUpdated as ICourseEdit;
    await put(`courses/${item.id}`, item);
    await Promise.all([this.updateGridRow(item.id, 'update'), this.loadItemEdit(item.id)]);
  }

  async loadItemData(itemId: number) {
    return await get<ICourseEdit>(`courses/${itemId}`);
  }

  async addSourceDialect(dialectId: number, copyDialectId: number) {
    const itemId = this.getItemId();
    await super.save();
    await put(`courses/${itemId}/add-source-dialect`, {
      dialectId,
      copyDialectId,
    });
    await this.loadItemEdit(itemId);
  }

  async addTargetDialect(dialectId: number, copyDialectId: number) {
    const itemId = this.getItemId();
    await super.save();
    await put(`courses/${itemId}/add-target-dialect`, {
      dialectId,
      copyDialectId,
    });
    await this.loadItemEdit(itemId);
  }
}
